<template>
  <div>
    {{ item.dt_aplicacao_br }}
    <i
      :class="
        item.meses != meses || item.dose_anterior == 1
          ? 'icofont-close-circled'
          : 'icofont-check-circled'
      "
      :style="{
        color: item.meses != meses || item.dose_anterior == 1 ? 'red' : 'green',
      }"
    ></i>
    <br />
    com {{ item.meses }} meses
    <span
      v-if="item.dose_anterior == 1"
      v-b-tooltip.hover.right
      title="Dose registrada como transcrição de caderneta."
      class="icon-tooltip"
    >
      <i class="icofont-info-circle"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: [Object, Boolean],
      default: false,
    },
    meses: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style></style>
